import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/today')({
  component: () => <Navigate to="/entry" search={{}} replace />,
});
